import React, { Component } from 'react'
import { Button, Table, Select, Input, Icon, Row, Col } from 'antd';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import moment from 'moment';

const Option = Select.Option;
const dateFormat = 'YYYY/MM/DD';
export default class LeaveApprovals extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            leave_type: [],
            leave_type_filter: [{ text: 'None', value: 'None' }],
            searchText: ''
        }

        this.handleApprove = this.handleApprove.bind( this );
        this.handleReject = this.handleReject.bind( this );
        this.handleLeaveType = this.handleLeaveType.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );

    }

    getColumnSearchProps = dataIndex => ({ 
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleLeaveType( leave_id, leave_type_id ){
        this.props.onHandleType( leave_id, leave_type_id );
    }

    handleApprove( e ){    
        
        $( e.target ).attr( 'disabled', true );
        this.props.onApprove( e.target.attributes.id.value, '' );

    }

    handleReject( e ){
        var remarks = prompt("Please enter your remarks:", "" );
        if (remarks != null && remarks !== '' ) {    
            this.props.onApprove( e.target.attributes.id.value, remarks );
        } else {
            alert( "Please enter your remarks!" );
        }

    }

    componentWillReceiveProps( nextProps ){

        
        this.setState({ data: nextProps.data });
        
        this.setState({
            leave_type: nextProps.dataLeaveType
        });
        
        if( nextProps.dataLeaveType ){
            
            let data_temp = [];
            
            nextProps.dataLeaveType.map( (item, k) => {
                data_temp.push( { text: item.leave_type_name, value: item.leave_type_id } );
            });
            
            this.setState({
                leave_type_filter: data_temp
            });
            
        }

    }

    render() {

        const leave_types = this.state.leave_type.map( (item, i) => <Option value={ item.leave_type_id }>{ item.leave_type_name }</Option> )

        const columns = [
            {
                title       : 'Leaves',
                key         : 'full_name',
                ...this.getColumnSearchProps( 'full_name' ),
                render: data => <div className="approvals_list">
                    <Row>
                        <Col span={8}><h3><Icon type="user" />&nbsp;&nbsp;{ data.full_name } <Link style={{fontSize: '10px',color: '#3030ff !important'}} to={ 'organization/employees/'+ data.user_id }>View Profile</Link> </h3></Col>
                        <Col span={8}><h3><Icon type="calendar" />&nbsp;&nbsp;{ data.from_date } - { data.to_date }</h3></Col>
                        <Col span={8}>
                            <h3 style={{ float: "left" }}>Approved By <em style={{color: '#666'}}>{ ( data.approved_by ) ? data.approved_by : 'Pending' }</em></h3>
                        </Col>
                    </Row>
                    <Row className="mrg_b_10">
                        <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;Current Leave Taken : <b>{ data.leave_taken }</b></span></Col>
                        <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;Current Leave Balance : <b>{ data.leave_balance }</b></span></Col>
                        <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;<em>Reason : { data.reason }</em></span></Col>
                    </Row>
                    <Row>
                        <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;Leave Type : { data.leave_name }</span></Col>
                        <Col span={8}>{ ( data.attachment ) ? <a target="_blank" href={ data.attachment }><span style={{color: '#1890ff'}}><Icon type="link"/> Click to Download</span></a> : <span style={{color: '#666'}}><Icon type="link"/> No Attachment</span> }</Col>
                        <Col span={8}>
                            <span>
                                <Button disabled={ ( data.approved === '1' ) ? true : false } type="primary" size={'small'} onClick={ ( e )=> this.handleApprove( e ) } id={ data.leave_id } className="mrg_r_10">
                                    Approve
                                </Button>
                                <Button type="danger" size={'small'} onClick={ ( e )=> this.handleReject( e ) } id={ data.leave_id } >
                                    Reject
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </div>
            },
        ]

        // const columns = [
        //     {
        //         title       : 'Employee Name',
        //         dataIndex   : 'full_name',
        //         key         : 'full_name',
        //         ...this.getColumnSearchProps( 'full_name' ),
        //     },
        //     {
        //         title       : 'Leave Type',
        //         key         : 'leave_type_id',
        //         width       : '10%',
        //         render      : data => <Select key={ data.leave_id }
        //             onChange={ (value) => this.handleLeaveType( data.leave_id, value ) }
        //             defaultValue={ data.leave_type_id } style={{ width: '100%' }}>
        //             { leave_types }
        //         </Select>,
        //         filters: this.state.leave_type_filter,
        //         onFilter: ( value, record ) => record.leave_type_id.indexOf(value) === 0,
        //     },
        //     {
        //         title       : 'From Date',
        //         dataIndex   : 'from_date',
        //         key         : 'from_date',
        //     },
        //     {
        //         title       : 'To Date',
        //         dataIndex   : 'to_date',
        //         key         : 'to_date',
        //     },
        //     {
        //         title       : 'LV Taken',
        //         dataIndex   : 'leave_taken',
        //         key         : 'leave_taken',
        //     },
        //     {
        //         title       : 'LV Balance',
        //         dataIndex   : 'leave_balance',
        //         key         : 'leave_balance',
        //     },
        //     {
        //         title       : 'Reason',
        //         dataIndex   : 'reason',
        //         key         : 'reason',
        //         width       : '20%',
        //     },
        //     {
        //         title       : 'Approved By',
        //         dataIndex   : 'approved_by',
        //         key         : 'approved_by',
        //     },
        //     {
        //         title       : 'Requested Date',
        //         dataIndex   : 'requested_date',
        //         key         : 'requested_date',
        //     },
        //     {
        //         title       : 'Attachment',
        //         key         : 'action',
        //         render: data => <span style={{ color: 'blue' }} key={data.leave_id}>
        //             { ( data.attachment ) ? <a target="_blank" style={{ fontSize: '9px' }} size={'small'} href={data.attachment} >Download</a> : '' }
        //         </span>,
        //     },
        //     {
        //         title       : 'Action',
        //         key         : 'action',
        //         render: data => <span key={data.leave_id}>
        //             <Button size={'small'} onClick={ ( e )=> this.handleApprove( e, data.approved ) } id={ data.leave_id } >
        //                 { ( data.approved === '1' ) ? 'Reject': 'Approve' }
        //             </Button>
        //             <Button size={'small'} onClick={ ( e )=> this.handleApprove( e, data.approved ) } id={ data.leave_id } >
        //                 { ( data.approved === '1' ) ? 'Reject': 'Approve' }
        //             </Button>
        //         </span>,
        //         filters: [{ text: 'Approved', value: '1' },{ text: 'Unapproved', value: '0' }],
        //         onFilter: ( value, record ) => record.approved.indexOf(value) === 0,
        //     }
        // ]

        return (
            <div>
                <Table size={ "small" } columns={ columns } dataSource={ this.state.data } />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/approvals/childs/leave.approvals.js